module.exports = __webpack_public_path__ + "static/media/oktoberfest.c7006509.jpg";